"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createEmployeeLoginSchema = exports.updateEmployeeMasterSchema = exports.createEmployeeMasterSchema = exports.employeeMasterShape = exports.employeeMaritalStatusEnum = exports.employeeGenderEnum = exports.employmentNatureEnum = exports.employmentStatusEnum = exports.employeeTypeEnum = void 0;
const zod_1 = require("zod");
// Employee Master enterprise rebuild.
exports.employeeTypeEnum = zod_1.z.enum([
    'DOCTOR',
    'NURSE',
    'TECHNICIAN',
    'PHARMACIST',
    'ADMINISTRATION',
    'ACCOUNTS',
    'RECEPTION',
    'LABORATORY',
    'RADIOLOGY',
    'PHYSIOTHERAPIST',
    'INSURANCE',
    'HOUSEKEEPING',
    'SECURITY',
    'MAINTENANCE',
    'CONTRACT',
    'TRAINEE',
]);
exports.employmentStatusEnum = zod_1.z.enum(['ACTIVE', 'INACTIVE', 'RESIGNED', 'RETIRED', 'SUSPENDED', 'CONTRACT']);
exports.employmentNatureEnum = zod_1.z.enum(['PERMANENT', 'CONTRACT', 'VISITING', 'CONSULTANT', 'INTERN', 'TRAINEE']);
exports.employeeGenderEnum = zod_1.z.enum(['MALE', 'FEMALE', 'OTHER']);
exports.employeeMaritalStatusEnum = zod_1.z.enum(['SINGLE', 'MARRIED', 'DIVORCED', 'WIDOWED']);
/**
 * `employeeCode` is deliberately NOT part of this shape — the service
 * auto-derives it from `employeeNumber` (kept as a distinct column for
 * spec fidelity, but not a second value an admin has to type in). See
 * `EmployeeMasterService.create()`'s own doc comment.
 */
exports.employeeMasterShape = {
    // Basic Information
    employeeNumber: zod_1.z.string().min(1).max(30),
    name: zod_1.z.string().min(1).max(255),
    displayName: zod_1.z.string().max(255).nullable().optional(),
    photoUrl: zod_1.z.string().max(500).nullable().optional(),
    gender: exports.employeeGenderEnum.nullable().optional(),
    dateOfBirth: zod_1.z.coerce.date().nullable().optional(),
    bloodGroup: zod_1.z.string().max(5).nullable().optional(),
    maritalStatus: exports.employeeMaritalStatusEnum.nullable().optional(),
    nationality: zod_1.z.string().max(100).nullable().optional(),
    religion: zod_1.z.string().max(100).nullable().optional(),
    category: zod_1.z.string().max(100).nullable().optional(),
    // Employment Details
    employeeType: exports.employeeTypeEnum,
    departmentId: zod_1.z.string().uuid(),
    designationId: zod_1.z.string().uuid(),
    reportingManagerId: zod_1.z.string().uuid().nullable().optional(),
    joiningDate: zod_1.z.coerce.date(),
    confirmationDate: zod_1.z.coerce.date().nullable().optional(),
    employmentStatus: exports.employmentStatusEnum.optional(),
    employmentNature: exports.employmentNatureEnum,
    // Contact Details
    mobileNumber: zod_1.z.string().max(20).nullable().optional(),
    alternateMobile: zod_1.z.string().max(20).nullable().optional(),
    contactEmail: zod_1.z.string().email().max(255).nullable().optional(),
    contactPhone: zod_1.z.string().max(20).nullable().optional(),
    emergencyContact: zod_1.z.string().max(255).nullable().optional(),
    emergencyContactNumber: zod_1.z.string().max(20).nullable().optional(),
    presentAddress: zod_1.z.string().nullable().optional(),
    permanentAddress: zod_1.z.string().nullable().optional(),
    // Professional Information
    qualification: zod_1.z.string().max(255).nullable().optional(),
    experienceYears: zod_1.z.number().int().min(0).nullable().optional(),
    registrationNumber: zod_1.z.string().max(100).nullable().optional(),
    specialization: zod_1.z.string().max(255).nullable().optional(),
    licenseExpiry: zod_1.z.coerce.date().nullable().optional(),
    // Hospital Configuration
    defaultWorkstation: zod_1.z.string().max(150).nullable().optional(),
    defaultCounter: zod_1.z.string().max(150).nullable().optional(),
    defaultBranchId: zod_1.z.string().uuid().nullable().optional(),
    defaultLocation: zod_1.z.string().max(150).nullable().optional(),
    defaultShiftId: zod_1.z.string().uuid().nullable().optional(),
    defaultCostCenterId: zod_1.z.string().uuid().nullable().optional(),
    // Login Configuration
    loginRequired: zod_1.z.boolean().optional(),
    approvalLevel: zod_1.z.number().int().min(0).nullable().optional(),
    // Attendance
    biometricId: zod_1.z.string().max(50).nullable().optional(),
    weeklyOff: zod_1.z.string().max(20).nullable().optional(),
    attendanceRequired: zod_1.z.boolean().optional(),
    // Payroll
    salaryGrade: zod_1.z.string().max(50).nullable().optional(),
    pfNumber: zod_1.z.string().max(50).nullable().optional(),
    esiNumber: zod_1.z.string().max(50).nullable().optional(),
    pan: zod_1.z.string().max(20).nullable().optional(),
    aadhaar: zod_1.z.string().max(20).nullable().optional(),
    bankName: zod_1.z.string().max(150).nullable().optional(),
    bankAccountNumber: zod_1.z.string().max(50).nullable().optional(),
    bankIfsc: zod_1.z.string().max(20).nullable().optional(),
    remarks: zod_1.z.string().nullable().optional(),
    creditLimit: zod_1.z.number().nonnegative().nullable().optional(),
};
exports.createEmployeeMasterSchema = zod_1.z.object(exports.employeeMasterShape);
exports.updateEmployeeMasterSchema = exports.createEmployeeMasterSchema.omit({ employeeNumber: true }).partial();
/** `POST /employees/:id/create-login` — Auto User Creation. */
exports.createEmployeeLoginSchema = zod_1.z.object({
    roleIds: zod_1.z.array(zod_1.z.string().uuid()).min(1).optional(),
});
//# sourceMappingURL=employee-master.schema.js.map